import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '@shared/services/auth-guard.service';
import { StepStatusGuard } from '@shared/services/step-status-guard.service';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard, StepStatusGuard],
    loadChildren: () => import('./tabs/tabs.module').then((m) => m.TabsPageModule)
  },
  {
    path: '',
    loadChildren: () => import('./public/public.module').then((m) => m.PublicModule)
  },
  {
    path: 'product/crowdinvesting',
    redirectTo: '/tabs/home'
  },
  {
    path: 'login',
    redirectTo: '/public/login',
    pathMatch: 'full'
  },
  {
    path: '',
    redirectTo: '/tabs/home',
    pathMatch: 'full'
  },
  {
    path: 'grow',
    loadChildren: () => import('./inyova-grow/inyova-grow.module').then((m) => m.InyovaGrowModule)
  }
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
